
import { defineComponent } from 'vue';
import AppHeader from './layout/header.vue';
import AppSidebar from './layout/sidebar.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '~app/core/auth';

export default defineComponent({
  name: 'app',
  components: {
    AppHeader,
    AppSidebar,
  },
  data: () => ({
    isDrawerExpanded: true,
  }),
  computed: {
    ...mapState(useAuthStore, ['isAuthenticated']),
  },
});
